export const CIVILOPNAME_LOADING = "CIVILOPNAME_LOADING";
export const CIVILOPNAME_RESET = "CIVILOPNAME_RESET";
export const GET_CIVILOPNAME = "GET_CIVILOPNAME";
export const GET_CIVILOPNAME_SUCCESS = "GET_CIVILOPNAME_SUCCESS";
export const GET_CIVILOPNAME_FAIL = "GET_CIVILOPNAME_FAIL";
export const DELETE_CIVILOPNAME = "DELETE_CIVILOPNAME"
export const DELETE_CIVILOPNAME_SUCCESS = "DELETE_CIVILOPNAME_SUCCESS"
export const DELETE_CIVILOPNAME_FAIL = "DELETE_CIVILOPNAME_FAIL"
export const UPDATE_CIVILOPNAME = "UPDATE_CIVILOPNAME"
export const UPDATE_CIVILOPNAME_SUCCESS = "UPDATE_CIVILOPNAME_SUCCESS"
export const UPDATE_CIVILOPNAME_FAIL = "UPDATE_CIVILOPNAME_FAIL"
export const ADD_NEW_CIVILOPNAME = "ADD_NEW_CIVILOPNAME"
export const ADD_CIVILOPNAME_SUCCESS = "ADD_CIVILOPNAME_SUCCESS"
export const ADD_CIVILOPNAME_FAIL = "ADD_CIVILOPNAME_FAIL"